import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/recordList/record/styles.scss';export default {
  "record": "_record_n0uv1_1",
  "locked": "_locked_n0uv1_8",
  "input": "_input_n0uv1_11",
  "resource": "_resource_n0uv1_27",
  "list": "_list_n0uv1_31",
  "clickable": "_clickable_n0uv1_35"
};